import { render, staticRenderFns } from "./salary-sendresult.vue?vue&type=template&id=01944390&scoped=true&"
import script from "./salary-sendresult.vue?vue&type=script&lang=js&"
export * from "./salary-sendresult.vue?vue&type=script&lang=js&"
import style0 from "./salary-sendresult.vue?vue&type=style&index=0&id=01944390&prod&scoped=true&lang=scss&"
import style1 from "./salary-sendresult.vue?vue&type=style&index=1&id=01944390&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01944390",
  null
  
)

export default component.exports